module.exports = __webpack_public_path__ + "images/butler/automation-light.664d88a0fc08655e416b.svg";